var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ul',{staticClass:"link-list"},_vm._l((_vm.pages),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }